import { render, staticRenderFns } from "./DeleteBeneficiaryReferent.vue?vue&type=template&id=3f8b5583&"
import script from "./DeleteBeneficiaryReferent.vue?vue&type=script&lang=js&"
export * from "./DeleteBeneficiaryReferent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports